var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShovel = function SvgShovel(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14814_1972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.04 2.28418V3.75293H29.7275V2.28418H31.5986V3.75293H33.2861V2.28418H35.1572V3.75293H36.8428V2.28418H38.7139V3.75293H40.4014V2.28418H42.2725V3.75293H43.96V2.28418H45.8311V3.75293H46.5342V14.459H41.707V19.0518H43.3418V27.6172H43.1602V29.5811H43.3418V33.8828H45.0068V25.2539H51.8828V60.2324H51.0371V66.0078L50.9893 66.127L50.9863 66.1328C50.9854 66.1351 50.9845 66.138 50.9834 66.1406C50.9808 66.1466 50.9772 66.1543 50.9736 66.1621C50.9664 66.1781 50.957 66.1984 50.9453 66.2217C50.9216 66.2686 50.888 66.3301 50.8428 66.4033C50.7518 66.5506 50.6128 66.7466 50.4092 66.9727C50.0008 67.426 49.337 67.9969 48.2822 68.5547C46.1755 69.6687 42.5185 70.7285 36.2178 70.7285C36.1448 70.7285 36.0723 70.7259 36 70.7256C35.9277 70.7259 35.8552 70.7285 35.7822 70.7285C29.4815 70.7285 25.8245 69.6687 23.7178 68.5547C22.663 67.9969 21.9992 67.426 21.5908 66.9727C21.3872 66.7466 21.2482 66.5506 21.1572 66.4033C21.112 66.3301 21.0784 66.2686 21.0547 66.2217C21.043 66.1984 21.0336 66.1781 21.0264 66.1621C21.0228 66.1543 21.0192 66.1466 21.0166 66.1406C21.0155 66.138 21.0146 66.1351 21.0137 66.1328L21.0107 66.127L20.9629 66.0078V60.2324H20.1172V25.2539H26.9932V33.8828H28.6582V29.5811H28.8398V27.6172H28.6582V19.0518H30.293V14.459H25.4658V3.75293H26.1689V2.28418H28.04Z",
    stroke: "#BDBDBD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0666 49.4333H31.0545C29.8919 49.4333 28.9492 48.4901 28.9492 47.328V24.9431C28.9492 23.7805 29.8924 22.8379 31.0545 22.8379H41.0666C42.2302 22.8379 43.1729 23.781 43.1729 24.9431V47.328C43.1734 48.4906 42.2302 49.4333 41.0666 49.4333Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0055 25.0244H20.1309V60.003H27.0055V25.0244Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8952 25.0244H45.2754V60.003H51.8952V25.0244Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8569 47.3458H41.3135V34.3067H50.3984V65.6516C50.3984 65.6516 48.6983 69.8471 36.2305 69.8471C23.7627 69.8471 21.7227 65.6516 21.7227 65.6516L21.8366 34.3047H30.8031L30.8569 47.3458Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.30317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3007 37.0357H47.9086V64.3507C47.2681 65.042 44.6417 67.1199 36.2227 67.1199C27.8137 67.1199 24.9633 65.0376 24.2168 64.297L24.3149 37.0327H31.8569",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6827 2.05469H26.1816V3.64582H27.6827V2.05469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2413 2.05469H29.7402V3.64582H31.2413V2.05469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7999 2.05469H33.2988V3.64582H34.7999V2.05469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3565 2.05469H36.8555V3.64582H38.3565V2.05469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9151 2.05469H40.4141V3.64582H41.9151V2.05469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4737 2.05469H43.9727V3.64582H45.4737V2.05469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5634 4.1748H26.1289V13.5778H45.5634V4.1748Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.30317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3817 4.63525H26.3418V7.50298H45.3817V4.63525Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.651583
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0668 24.9424H31.0547V47.3273H41.0668V24.9424Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.30317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0668 12.8218H31.0547V22.2043H41.0668V12.8218Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.30317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4327 18.8223H28.75V27.3881H30.4327V18.8223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4327 29.3511H28.75V34.5664H30.4327V29.3511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3546 18.8223H41.6719V27.3881H43.3546V18.8223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3546 29.3511H41.6719V34.5664H43.3546V29.3511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9284 19.9585H33.1914V27.8962H38.9284V19.9585Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.04252
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4141 41.2407H31.7246V46.668H40.4141V41.2407Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6037 36.8301H23.877V52.2497H31.6037V36.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2415 64.2974H25.9453V68.699H29.2415V64.2974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.971 64.2974H42.6758V68.699H45.971V64.2974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2074 58.9245C45.3726 58.9245 46.3171 57.98 46.3171 56.8148C46.3171 55.6496 45.3726 54.7051 44.2074 54.7051C43.0422 54.7051 42.0977 55.6496 42.0977 56.8148C42.0977 57.98 43.0422 58.9245 44.2074 58.9245Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14814_1972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShovel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "shovel.a22db2a02ec482f8da8f28b0e57fb522.svg";